module.exports = __webpack_public_path__ + "img/companyTitle.7cdd7a09.png";